
import allgame from "../../assets/images/sidebar/AllGames.svg";
import four8d from "../../assets/images/sidebar/48D.svg";
import three6d from "../../assets/images/sidebar/36D.svg";
import two4d from "../../assets/images/sidebar/24D.svg";
import one2d from "../../assets/images/sidebar/12D.svg";
import sibco from "../../assets/images/sidebar/SB.svg";
import dragon from "../../assets/images/sidebar/DT.svg";
import poker from "../../assets/images/sidebar/PD.svg";
import MultiBet from "../../assets/images/sidebar/MB.svg";
import Superwheel from "../../assets/images/sidebar/SW.png";
import Arcade from "../../assets/images/sidebar/AG.png";
export const iconData = {
    "AllGames": allgame,
    "48D": four8d,
    "36D": three6d,
    "24D": two4d,
    "12D": one2d,
    "SB": sibco,
    "DT": dragon,
    "PD": poker,
    "WH": Superwheel,
    "MB": MultiBet,
    "ARCADE": Arcade
};
